import * as Yup from 'yup'

import { useEffect, useState } from "react"

import { IPasswordProps } from './IPasswordProps'
import { InputFieldHelper } from '../InputHelper'

export const usePasswordValidationSchema = (props: IPasswordProps) => {
    const [schema, setSchema] = useState<Yup.StringSchema>();

    useEffect(() => {
        const { label, placeholder, required, minLength, maxLength, regEx } = props

        let schema = Yup.string()
        if (required)
            schema = schema.required();

        if (label)
            schema = schema.label(label);
        else if (placeholder)
            schema = schema.label(placeholder);

        if (minLength !== undefined)
            schema = schema.min(Number(minLength));

        if (maxLength !== undefined)
            schema = schema.max(Number(maxLength));

        if (regEx && InputFieldHelper.isValidRegEx(regEx)) {
            const regexPattern = new RegExp(regEx);
            schema = schema.matches(regexPattern);
        }

        setSchema(schema)
        // eslint-disable-next-line
    }, [props])

    return schema
}
